var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-layout"}},[_c('TheNavMenu',{staticClass:"layout-left the-nav-menu"}),_c('div',{staticClass:"layout-right"},[_c('TheHead'),_c('div',{staticClass:"rightContent"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }